import {Home} from "./components/NHome";

const AppRoutes = [
    {
        index: true,
        element: <Home />
    }
];

export default AppRoutes;
